import { NgModule } from '@angular/core';
import {
  BrowserModule,
  BrowserTransferStateModule,
} from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MapComponent } from './components/map/map.component';
import { LandingComponent } from './components/landing/landing.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { HeaderComponent } from './components/header/header.component';
import { CommonModule, KeyValuePipe } from '@angular/common';
import { MarkerInfoComponent } from './components/marker-info/marker-info.component';
import { FiltersComponent } from './components/filters/filters.component';
import { FormsModule } from '@angular/forms';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { HttpClientModule } from '@angular/common/http';
import { ContactsComponent } from './components/contacts/contacts.component';
import { CookiesPolicyComponent } from './components/cookies-policy/cookies-policy.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { RentalRequestModalComponent } from './components/rental-request-modal/rental-request-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    LandingComponent,
    HeaderComponent,
    MarkerInfoComponent,
    FiltersComponent,
    AboutUsComponent,
    ContactsComponent,
    CookiesPolicyComponent,
    PrivacyPolicyComponent,
    RentalRequestModalComponent,
  ],
  entryComponents: [],
  imports: [
    CommonModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    GoogleMapsModule,
    FormsModule,
    BrowserTransferStateModule,
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}
